import {
  ADD_MEMBER,
  AddMember,
  allocateTime,
  CREATE_TEAM,
  CreateTeam,
  GET_MEMBER_SIMULATIONS,
  GET_MEMBER_SIMULATIONS_COUNTS,
  GETMY_TEAM,
  GetTeam,
  getTeamMemberSimulations,
  HttpRequest,
  JOIN_TEAM,
  JoinByLink,
  LEAVE_TEAM,
  leaveTeam,
  REMOVE_MEMBER,
  removeMember,
  RequestMethod,
  simulationsCount,
  UPDATE_LICENCE,
  updateLicence,
  UPLOAD_MEMBERS,
  uploadCsv
} from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HttpResponse } from '@vapi-ai/web/dist/api';

export const joiningTeam: any = createAsyncThunk(JOIN_TEAM, async (payload: any) => {
  const response = (await HttpRequest({
    url: JoinByLink,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const createNewTeam: any = createAsyncThunk(CREATE_TEAM, async (payload: any) => {
  const response = (await HttpRequest({
    url: CreateTeam,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const addNewMember: any = createAsyncThunk(ADD_MEMBER, async (payload: any) => {
  const response = (await HttpRequest({
    url: AddMember,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const updateMemberLicence: any = createAsyncThunk(UPDATE_LICENCE, async (payload: any) => {
  const response = (await HttpRequest({
    url: updateLicence,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const removeMembers: any = createAsyncThunk(REMOVE_MEMBER, async (payload: any) => {
  const response = (await HttpRequest({
    url: removeMember,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const leaveMyTeam: any = createAsyncThunk(LEAVE_TEAM, async (payload: any) => {
  const response = (await HttpRequest({
    url: leaveTeam,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const uploadCsvMembers: any = createAsyncThunk(
  UPLOAD_MEMBERS,
  async (payload: { file: File; teamId: string }) => {
    const formData = new FormData();
    formData.append('file', payload.file); // Append CSV file
    formData.append('teamId', payload.teamId); // Append teamId

    const response = (await HttpRequest({
      url: uploadCsv,
      method: RequestMethod.POST,
      body: formData, // Send FormData
      //@ts-ignore
      headers: {
        'Content-Type': 'multipart/form-data' // Ensure correct content type
      }
    })) as HttpResponse<any>;

    return response;
  }
);

export const updateMemberTime: any = createAsyncThunk(REMOVE_MEMBER, async (payload: any) => {
  const response = (await HttpRequest({
    url: allocateTime,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const getMyTeamSimulations: any = createAsyncThunk(GET_MEMBER_SIMULATIONS_COUNTS, async (payload: any) => {
  const { limit } = payload;

  const url = `${simulationsCount}?limit=${limit}`;
  const response = (await HttpRequest({
    url: url,
    method: RequestMethod.GET,
    body: payload
  })) as HttpResponse<any>;

  return response;
});
